import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { SeriesDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { BulkModStatusControl } from '@/components/user_catalog/BulkModStatusControl';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { SERIES_DEFAULT_TAB, SERIES_SHOW_TABS } from '../constants';
import { SeriesShowHeader } from './SeriesShowHeader';
import { SeriesGeneralTab } from './SeriesGeneralTab';
import { CollectionPublicationsTable } from '@/components/user_catalog/collections/CollectionPublicationsTable';
import { SeriesCollectionTab } from './SeriesCollectionTab';
import { SearchPopularityCard } from '@/components/common/show/SearchPopularityCard';

export const SeriesShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<SeriesDetailOut>({
    resource: 'user_catalog.series',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('user_catalog.series', record?.name);

  const [activeTab, onTabChange] = useShowTab(
    SERIES_SHOW_TABS,
    SERIES_DEFAULT_TAB
  );

  return (
    <Show
      isLoading={isLoading}
      contentProps={bareShowContentProps}
      headerButtons={({ defaultButtons }) => (
        <>
          {record?.id != null && (
            <BulkModStatusControl
              resource="user_catalog.series"
              ids={[record.id]}
              onSuccess={() => query.refetch()}
            />
          )}
          {defaultButtons}
        </>
      )}
    >
      {record && (
        <>
          <SeriesShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && <SeriesGeneralTab record={record} />}
            {activeTab === 'publications' && (
              <CollectionPublicationsTable
                collectionId={record.id}
                collectionKind={record.collection_kind}
              />
            )}
            {activeTab === 'collection' && (
              <SeriesCollectionTab record={record} />
            )}
            {activeTab === 'search' && (
              <SearchPopularityCard value={record.search_popularity} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
